// useLanguageDetection.js
import { useDispatch } from "react-redux";
import { resolveLanguage } from "../utils/languageDetectionManager";
import { useApi } from "../hooks/useApi";
import {
  setIsTextLanguageDetecting,
  setTextLanguageDetectionError,
} from "../store/features/message/textContentSlice";
import { setChatConfig } from "../utils/chatConfigStorage";

export const useLanguageDetection = () => {
  const api = useApi();
  const dispatch = useDispatch();

  const detectLanguage = async ({
    journeyType, // "TEXT" | "VOICE"
    chatId,
    query,
    audioBase64,
    samplingRate,
  }) => {
    try {
      // 🔄 START STATUS (Redux only for UI)
      if (journeyType === "TEXT") {
        dispatch(setIsTextLanguageDetecting(true));
      }

      const lang = await resolveLanguage({
        journeyType,

        // TEXT
        textOptions: {
          query,
          sendRequest: api.sendRequest,
        },

        // VOICE
        audioOptions: {
          audioBase64,
          samplingRate,
          sendRequest: api.sendRequest,
        },
      });

      const dataToBeSetInLocal = {
        language: lang,
        languageLocked: true,
        journey: journeyType,
        journeyLocked: true,
      };

      // ✅ Store once (single source of truth)
      if (lang && lang!=="unknown") {
        setChatConfig(dataToBeSetInLocal);
      }

      // console.log("Detected language in hook:", {
      //   lang,
      //   dataToBeSetInLocal,
      // });

      return lang;
    } catch (err) {
      // ❌ ERROR (TEXT only)
      if (journeyType === "TEXT") {
        dispatch(setTextLanguageDetectionError(err));
      }
      return "en";
    } finally {
      // 🧹 COMPLETE STATUS
      if (journeyType === "TEXT") {
        dispatch(setIsTextLanguageDetecting(false));
      }
    }
  };

  return { detectLanguage };
};
